import React, { Suspense } from 'react';

import Modal from '~/components/modals/modal';
import ShipNow from '~/components/modals/ship-now/ship-now';
import { safeLazy } from '~/utils/safe-lazy';

import modalStyles from '~/components/modals/modal.module.scss';

const ShipNowPayment = safeLazy(
  () => import('~/components/modals/ship-now/ship-now-payment')
);

const ShipNowModal = ({ onClose, isOpen, order, shipment }) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <Content onClose={onClose} order={order} shipment={shipment} />
  </Modal>
);

export default ShipNowModal;

const Content = ({ order, shipment, onClose }) => {
  return (
    <div className={modalStyles.shipNowModal}>
      {shipment?.isLegacyFlexPay ? (
        <Suspense fallback={null}>
          <ShipNowPayment order={order} shipment={shipment} onClose={onClose} />
        </Suspense>
      ) : (
        <ShipNow shipment={shipment} onClose={onClose} />
      )}
    </div>
  );
};
